import { stationsActions } from '../reducer';

export const resetSelectedStationOnMap = () => stationsActions.resetSelectedStationOnMap();
